import { render, staticRenderFns } from "./manual-post-process.vue?vue&type=template&id=dcf96820&"
import script from "./manual-post-process.vue?vue&type=script&lang=js&"
export * from "./manual-post-process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports